/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 *
 *
 * 1 = MOTRAMP
 *
 * 2 = COLLECT
 *
 * 3 = RECALL
 *
 * 4 = WAITING
 *
 * 5 = StandartBooking
 *
 * 99 = Loan
 *
 * 100 = Diagnostic
 *
 * 101 = MOTRAMPHours
 *
 * 102 = TotalHours
 */
export enum WlAppointType {
  MOTRAMP = 1,
  COLLECT = 2,
  RECALL = 3,
  WAITING = 4,
  StandartBooking = 5,
  Loan = 99,
  Diagnostic = 100,
  MOTRAMPHours = 101,
  TotalHours = 102,
}
